module.exports = __webpack_public_path__ + "img/header-bg.180e87ae.png";